import { WorkawareApi } from "apis/WorkawareApi";


export class assetMaintenanceSchedulesService {
    _api: WorkawareApi
    constructor(api: WorkawareApi) {
        this._api = api
    }
    get = () => {
        return new Promise<any>((resolve, reject) => {
            this._api.assetMaintenanceSchedules.get()
                .then((result) => resolve(result))
                .catch(error => reject(error))
        })
    }

}